import React from 'react';
import { IconWrapper } from '../runtime';
export default IconWrapper('loading-static', false, function (props) {
  return /*#__PURE__*/React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 246 246"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: props.colors[0],
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.757,7.10542736e-15 C54.96625,7.10542736e-15 -1.50990331e-14,54.96525 -1.50990331e-14,122.75725 C-1.50990331e-14,190.5505 54.964,245.51475 122.757,245.51475 C129.3955,245.51475 134.777,240.133 134.777,233.49475 C134.777,226.85625 129.3955,221.47475 122.757,221.47475 C68.24075,221.47475 24.03975,177.27375 24.03975,122.75725 C24.03975,68.24225 68.243,24.04 122.75725,24.04 C177.2735,24.04 221.4745,68.241 221.4745,122.7575 C221.4745,129.39575 226.856,134.7775 233.4945,134.7775 C240.13275,134.7775 245.5145,129.39575 245.5145,122.7575 C245.5145,54.96425 190.55025,7.10542736e-15 122.757,7.10542736e-15 L122.757,7.10542736e-15 Z"
  }))));
});